"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 3.25a8.75 8.75 0 1 0 .001 17.501A8.75 8.75 0 0 0 12 3.25m.498 3.189c.459-.54 1.225-.943 1.861-.967.016.073.024.161.024.25 0 .653-.282 1.305-.669 1.773-.427.516-1.144.902-1.716.902a1 1 0 0 1-.169-.016 1 1 0 0 1-.024-.226c0-.661.33-1.305.693-1.716m3.634 10.129c-.54.774-1.112 1.563-1.966 1.563-.87 0-1.088-.508-2.079-.508-.975 0-1.321.524-2.103.524-.79 0-1.338-.725-1.966-1.612-.733-1.047-1.329-2.667-1.329-4.198 0-2.466 1.603-3.771 3.183-3.771.83 0 1.531.548 2.063.548.491 0 1.273-.58 2.232-.58.355 0 1.652.032 2.506 1.257-.073.056-1.362.79-1.362 2.417 0 1.877 1.636 2.546 1.692 2.562-.016.04-.266.91-.87 1.797z"
}), 'AppleRing');
//# sourceMappingURL=index.js.map